import moment from "moment";
import { RootState } from "../root-reducer";
import {
  FlatItem,
  ApiFlatItem,
  ChildFlatItem,
  ApiChildFlatItem,
} from "../../types/general";
import { AllClaims } from "../../types/claim";
import { AllPlans } from "../../types/plan";
import { AceClaimItem, ClaimItem } from "../../types/claim-item";
import { Damage } from "../../types/damage";
import { UploadedFile } from "../../types/uploaded-file";
import { navigateTo } from "../../helper";
import queryString from "query-string";
import RouteNames from "../../routes/type";

export const mapApiFlatData = (payload: ApiFlatItem): FlatItem => ({
  id: payload?.id || payload?.ID,
  name: payload.name || payload.NAME,
});

export const mapApiChildFlatData = (
  payload: ApiChildFlatItem
): ChildFlatItem => ({
  id: payload?.id || payload?.ID,
  name: payload.name || payload.NAME,
  parrentId: payload.Parent_Type_ID,
});

export const getPlans = (state: RootState): AllPlans[] => state.user.plans;
export const getClaims = (state: RootState): AllClaims[] => state.user.claims;

export const mapApiClaimItem = (payload: unknown): AceClaimItem => {
  return {
    id: payload["id"],
    name: payload["Name"],
    manufacturer: payload["manufacturer"],
    warrntyId: payload?.["warranty"]?.["id"],
    material: payload["material"],
    color: payload["color"],
    warranty_line_item_guid: payload["warranty_line_item_guid"],
    claimId: payload["Claim"]["id"],
    documents_and_photos: payload["documents_and_photos"]
      ? payload["documents_and_photos"].split(",")
      : [],
  };
};

export const MapApiDamage = (payload): Damage => {
  return {
    id: payload["id"],
    damageCategory: payload["damage_type"],
    specificLocation: payload["specific_location"],
    specificDamage: payload["specific_damage"],
    damageDate: payload["da_damage_date"]
      ? moment(payload["da_damage_date"], "YYYY-MM-DD").toDate()
      : null,
    occuredReason: payload["how_did_occur"],
    actionTaken: payload["actions_taken"],
    notes: payload["note_damage_area"],
  };
};

export const mapCustomerInfo = (payload) => {
  return {
    email: payload?.["Email"] || "",
    phone: payload?.["Home_Phone"] || "",
    address1: payload?.["Mailing_Street"] || "",
    address2: payload?.["Mailing_Street_2"] || "",
    city: payload?.["Mailing_City"] || "",
    state: payload?.["Mailing_State"] || "",
    zip: payload?.["Mailing_Zip"] || "",
    allowSMS: !!payload?.["sms_opt_in"],
  };
};

export const getItemType = (fileName) => {
  const ext = fileName.split(".").pop() || "";
  return ext.toLowerCase() === "pdf" ? "pdf" : "3003";
};

export const nextStepRedirect = (step, extarProps = {}) => {
  const parsed = queryString.parse(window.location.search);
  navigateTo(
    `/${RouteNames.CREATE_ACE2_CLAIM}?${queryString.stringify({
      ...parsed,
      ...extarProps,
      step,
    })}`
  );
};
